module.exports = __webpack_public_path__ + "img/empty-group-sessions.3b96d479.svg";